var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',[_vm._v("\n    ©Copyright 2018 Hoteliers Dot Guru (Thailand) Co., Ltd\n  ")])])}]

export { render, staticRenderFns }